import React from 'react';
import styles from './detail-card.module.css';
import ItemText from './item-text.jsx';
import ItemImg from './item-image.jsx';
import ItemVideo from './item-video.jsx';


class detailCard extends React.Component{
   constructor(props){
     super(props);
     this.state = {
      showContent: []
     }
   }
    onCloseContent(index){
      this.state.showContent[index] = !this.state.showContent[index]
      this.setState({
        showContent: this.state.showContent,
      })
    }
    render(){
      if(this.props.data && this.props.data.length>0){
        if(this.props.data.length != this.state.showContent.length){
          this.props.data.map((items,index) =>{
            this.state.showContent[index] = this.props.type != 'SolvingProblem' ? false : true;
          })
          this.setState({
            showContent: this.state.showContent,
          })
        }
        return (
          <div>
           {this.props.data.map((items,index) => (
              <div className={styles.pcBackground}>
                 {this.props.type != 'SolvingProblem'?
                    <div className={styles.infoGroup} >
                      <a onClick={ () => { this.onCloseContent(index)} } href='javascript:void(0)'>
                        {items.name}
                       <div className={(this.state.showContent[index] ? styles.infoUp : styles.infoDown)}></div>
                      </a>
                    </div>
                    :null
                 }
                {/* <div className={styles.infoGroup} >
                  <a onClick={ () => { this.onCloseContent(index)} } href='javascript:void(0)'>{items.name}</a>
                </div> */}
                <div className={ (this.state.showContent[index] ? '':styles.hide) + ' ' +styles.infoItems}>
                  {items.items.map((item) => (
                    item.type == 'text'? 
                      <ItemText data={item}></ItemText>
                      : 
                      item.type == 'image' ? 
                        <ItemImg data={item}></ItemImg>
                        :
                        <ItemVideo data={item}></ItemVideo>
                  ))}
                </div>
              </div>
            ))}
          </div>
          )
      }else{
        return (
          <div></div>
        )
      }
    }
  }
export default detailCard